import { areCookiesAuthorized, Batch, combine, commonInit, getTimestamp, HttpRequest, Observable, startAutomaticErrorCollection } from '@datadog/browser-core';
import { startLoggerSession } from '../domain/loggerSession';
import { buildEnv } from './buildEnv';
export function startLogs(userConfiguration, errorLogger, getGlobalContext) {
  var _a = commonInit(userConfiguration, buildEnv),
      configuration = _a.configuration,
      internalMonitoring = _a.internalMonitoring;

  var errorObservable = userConfiguration.forwardErrorsToLogs !== false ? startAutomaticErrorCollection(configuration) : new Observable();
  var session = startLoggerSession(configuration, areCookiesAuthorized(configuration.cookieOptions));
  return doStartLogs(configuration, errorObservable, internalMonitoring, session, errorLogger, getGlobalContext);
}
export function doStartLogs(configuration, errorObservable, internalMonitoring, session, errorLogger, getGlobalContext) {
  internalMonitoring.setExternalContextProvider(function () {
    return combine({
      session_id: session.getId()
    }, getGlobalContext(), getRUMInternalContext());
  });
  var batch = startLoggerBatch(configuration, session);
  errorObservable.subscribe(function (error) {
    errorLogger.error(error.message, combine({
      date: getTimestamp(error.startTime),
      error: {
        kind: error.type,
        origin: error.source,
        stack: error.stack
      }
    }, error.resource ? {
      http: {
        method: error.resource.method,
        status_code: error.resource.statusCode,
        url: error.resource.url
      }
    } : undefined, getRUMInternalContext(error.startTime)));
  });
  return function (message, currentContext) {
    if (session.isTracked()) {
      batch.add(message, currentContext);
    }
  };
}

function startLoggerBatch(configuration, session) {
  var primaryBatch = createLoggerBatch(configuration.logsEndpoint);
  var replicaBatch;

  if (configuration.replica !== undefined) {
    replicaBatch = createLoggerBatch(configuration.replica.logsEndpoint);
  }

  function createLoggerBatch(endpointUrl) {
    return new Batch(new HttpRequest(endpointUrl, configuration.batchBytesLimit), configuration.maxBatchSize, configuration.batchBytesLimit, configuration.maxMessageSize, configuration.flushTimeout);
  }

  return {
    add: function add(message, currentContext) {
      var contextualizedMessage = assembleMessageContexts({
        service: configuration.service,
        session_id: session.getId()
      }, currentContext, getRUMInternalContext(), message);
      primaryBatch.add(contextualizedMessage);

      if (replicaBatch) {
        replicaBatch.add(contextualizedMessage);
      }
    }
  };
}

export function assembleMessageContexts(defaultContext, currentContext, rumInternalContext, message) {
  return combine(defaultContext, currentContext, rumInternalContext, message);
}

function getRUMInternalContext(startTime) {
  var rum = window.DD_RUM;
  var context = rum && rum.getInternalContext ? rum.getInternalContext(startTime) : undefined;

  if (!context || !context.session) {
    return context;
  } // TODO settle on integration strategy
  // tslint:disable:no-unsafe-any


  var v2context = context;
  v2context.session_id = v2context.session.id;
  v2context.application_id = v2context.application.id;

  if (v2context.action) {
    v2context.user_action = {
      id: v2context.action.id
    };
  } // tslint:enable:no-unsafe-any


  return v2context;
}